/* eslint-disable react/forbid-prop-types,react/require-default-props,react/destructuring-assignment,jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { FontAwesome } from '../FontAwesome';
import './Paginate.scss';
import { Select } from '../Select/component';
import { NumberField } from '../NumberField/component';

export class Paginate extends React.Component {
  static propTypes = {
    totalPages: PropTypes.number,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.any.isRequired,
    totalResults: PropTypes.number,
    hasNextPage: PropTypes.bool,
    showPageSelector: PropTypes.bool,
    handlePageChange: PropTypes.func.isRequired,
    handlePageSizeChange: PropTypes.func,
    showPageSizeSelector: PropTypes.bool,
    pageSizeOptions: PropTypes.array,
  };

  static defaultProps = {
    pageSizeOptions: [10, 25, 50, 100, 'all'],
    totalPages: null,
    totalResults: null,
    hasNextPage: false,
    showPageSelector: false,
  };

  componentWillMount() {
    const { page } = this.props;
    this.handlePageChangedDebounced = _.debounce((newPage) => {
      this.props.handlePageChange(newPage);
    }, 300);

    this.setState({ page });
  }

  componentWillReceiveProps(nextProps) {
    const { page } = nextProps;
    this.setState({ page });
  }

  onPageSizeChange = (value) => {
    if (_.isFunction(this.props.handlePageSizeChange)) {
      this.props.handlePageSizeChange(value);
    }
  };

  onPreviousClick = () => {
    const { page } = this.state;
    if (page > 1) {
      const newPage = Math.max(1, page - 1);
      this.handlePageChangedDebounced(newPage);
      this.setState({ page: newPage });
    }
  };

  onPageChange = (page) => {
    this.handlePageChangedDebounced(page);
    this.setState({ page });
  };

  onNextClick = () => {
    const { page } = this.state;
    const { totalPages, hasNextPage } = this.props;

    let newPage = page;
    if (hasNextPage) {
      newPage = page + 1;
    } else if (totalPages !== null && page < totalPages) {
      newPage = Math.min(totalPages, page + 1);
    }
    if (newPage !== page) {
      this.handlePageChangedDebounced(newPage);
      this.setState({ page: newPage });
    }
  };

  render() {
    const { page } = this.state;
    const {
      totalPages,
      pageSize,
      showPageSizeSelector,
      pageSizeOptions,
      totalResults,
    } = this.props;
    let { hasNextPage, showPageSelector } = this.props;

    hasNextPage = hasNextPage || (totalPages && page < totalPages);
    showPageSelector =
      showPageSelector ||
      hasNextPage ||
      page > 1 ||
      (totalPages && totalPages > 1);

    return (
      <react-paginate>
        <div className="paginate-left">
          {showPageSizeSelector && (
            <Select
              className="pageSize"
              value={pageSize}
              onValueChange={this.onPageSizeChange}
              options={pageSizeOptions.map((pageSizeOption) => ({
                value: pageSizeOption,
                label: parseInt(pageSizeOption, 10)
                  ? `${pageSizeOption} per page`
                  : 'Show All',
              }))}
            />
          )}
          {totalResults !== null && <div>Total: {totalResults}</div>}
        </div>
        {!!showPageSelector && (
          <ul className="paginate-right">
            <li>Page</li>
            {/* TODO: Previous and Next buttons should be using Button component */}
            {/* Blocker is that Button is using bootstrap global css */}
            <li
              className={classNames('previous', { disabled: page === 1 })}
              onClick={this.onPreviousClick}
            >
              <FontAwesome name="caret-left" />
            </li>
            <li className="page">
              <NumberField
                value={page}
                min={1}
                max={totalPages || Number.POSITIVE_INFINITY}
                className="paginate-page"
                onValueChange={this.onPageChange}
              />
            </li>
            <li
              className={classNames('next', { disabled: !hasNextPage })}
              onClick={this.onNextClick}
            >
              <FontAwesome name="caret-right" />
            </li>
            {!!totalPages && <li>of {totalPages}</li>}
          </ul>
        )}
      </react-paginate>
    );
  }
}
